import axios from '../axios'
import { checkResponse, getProjectId } from '../utils'

/**
 * @function getTHUcases 获取退回区级案件列表
 * @param {Number} id 任务 id
 */
const getTHUcases = (id, query, page) => {
  return axios
    .get(
      `/api/v1/projects/${getProjectId()}/tasks/${id}/ucases?page=${page}&${query}`
    )
    .then(checkResponse)
}

/**
 * @function getTHTabs 获取退回区级案件列表
 * @param {Number} id 任务 id
 */
const getTHTabs = (tid,uid) => {
  return axios
    .get(
      `/api/v1/projects/${getProjectId()}/tasks/${tid}/ucases/${uid}/steps?datetimeFormat=datetime&view=web`
    )
    .then(checkResponse)
}

/**
 * @function getTHTabs 获取退回区级案件列表
 * @param {Number} id 任务 id
 */
const getTHDeleteTabs = (tid,uid) => {
  return axios
    .get(
      `/api/v1/projects/${getProjectId()}/tasks/${tid}/ucases/${uid}/steps?query_deleted=true&datetimeFormat=datetime&view=web`
    )
    .then(checkResponse)
}

/**
 * @function deleteUcase 删除案件
 * @param {Number} id 案件 id
 */
const deleteTHUcase = (tid,uid) => {
  return axios
    .delete(`/api/v1/projects/${getProjectId()}/tasks/${tid}/ucases/${uid}`)
    .then(checkResponse)
}

/**
 * @function updateUcase 编辑案件
 * @param {Number} id ucase id
 * @param {Object} data
 * @returns {Object} res {deatil}
 */
const updateTHUcase = (tid, uid, data) => {
  return axios
    .put(`/api/v1/projects/${getProjectId()}/tasks/${tid}/ucases/${uid}`, { data })
    .then(checkResponse)
}

/**
 * @function getUcaseStatusList 获取所有状态
 * @returns {Array} statusList
 */
const getTHStatusList = (tid) => {
  return axios
    .get(`/api/v1/projects/${getProjectId()}/tasks/${tid}/ucases/all_stages?as=selects`)
    .then(checkResponse)
}

/**
 * @function recoverUcase
 * @desc 恢复案件
 * @returns {Object}
 */
const recoverTHUcase = (tid,uids) => {
  return axios
    .put(`/api/v1/projects/${getProjectId()}/tasks/${tid}/ucases/bulk_recover`, { ids: uids })
    .then(checkResponse)
}

const getTHDetail = (taskid, ucaseid) => {
  return axios
    .get(`/api/v1/projects/${getProjectId()}/tasks/${taskid}/ucases/${ucaseid}/spec?datetime_format=datetime&view=web`)
    .then(checkResponse)
}

const getTHDeleteDetail = (taskid, ucaseid) => {
  return axios
    .get(`/api/v1/projects/${getProjectId()}/tasks/${taskid}/ucases/${ucaseid}/spec?query_deleted=true&datetime_format=datetime&view=web`)
    .then(checkResponse)
}

export{
  getTHUcases,
  getTHTabs,
  deleteTHUcase,
  updateTHUcase,
  getTHStatusList,
  recoverTHUcase,
  getTHDeleteTabs,
  getTHDetail,
  getTHDeleteDetail
}
